import { SeatAvailabilityStatus } from '@vista-digital/ocapi-types/v1';
import { seatAvailabilityStatusValidator } from '@vista-digital/occ-domain';
import { Validator } from '@vista-digital/validator';
import { seatAppearanceRuleValidator } from './seat-appearance-rule';
import { defaultSeatTypeAppearanceConfig, seatTypeAppearanceConfigValidator } from './seat-type-appearance';
export const defaultOccSeatingSeatsConfig = {
    minimumSize: 44,
    margin: 0,
    appearance: defaultSeatTypeAppearanceConfig,
    appearanceRules: [],
    allowSeatsInUnallocatedAreasToBeSelected: false,
    defaultAvailabilityStatus: SeatAvailabilityStatus.Sold,
    legacyMode: false
};
export const occSeatingSeatsConfigValidator = Validator.object({
    minimumSize: Validator.number({ min: 0 }),
    margin: Validator.number({ min: 0 }),
    appearance: seatTypeAppearanceConfigValidator,
    appearanceRules: Validator.array({ items: seatAppearanceRuleValidator }),
    allowSeatsInUnallocatedAreasToBeSelected: Validator.boolean(),
    defaultAvailabilityStatus: seatAvailabilityStatusValidator,
    legacyMode: Validator.boolean()
});
//# sourceMappingURL=seats.js.map